import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AppTypeEnum } from '../../enums';
import { filter } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { NavigatorHelper, StorageHelper } from '../../helpers';
import { StorageConstants } from '../../constants';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  public selectedAppType: AppTypeEnum;

  public appTypeEnum = AppTypeEnum;

  private router = inject(Router);
  private urlSignal = signal(this.router.url);

  public appTypes = [
    {
      title: 'BindingApp',
      type: AppTypeEnum.binding,
      isVisible: true
    },
    {
      title: 'TestingApp',
      type: AppTypeEnum.testing,
      isVisible: true
    },
    {
      title: 'StockingApp',
      type: AppTypeEnum.stocking,
      isVisible: false
    }
  ]

  constructor(
  ) {
    const stockingAllowed = StorageHelper.getItem<boolean>(StorageConstants.STOCKING_ALLOWED);
    if (stockingAllowed) {
      this.appTypes[2].isVisible = true;
    }
    effect(() => {
      this.selectedAppType = NavigatorHelper.appType() || AppTypeEnum.binding;
      if (this.selectedAppType === AppTypeEnum.stocking) {
        this.appTypes[2].isVisible = true;
        StorageHelper.setItem(StorageConstants.STOCKING_ALLOWED, true);

      }
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(event => {
          this.urlSignal.set((event as NavigationEnd).urlAfterRedirects);
        });
    });
  }

  public isHome = computed(() => {
    return this.urlSignal().startsWith('/home');
  });

  public setAppType(appType: AppTypeEnum) {
    NavigatorHelper.setAppType(appType);
  }
}
